import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { faqData } from '../data/mock';
import { applyPageMeta } from '../utils/seo';
import Header from './Header';
import Footer from './Footer';

const FAQ = () => {
  const navigate = useNavigate();

  useEffect(() => {
    applyPageMeta({
      title: 'FAQ | Tiago Cardoso',
      description: 'Respostas rápidas sobre serviços, tecnologia e atuação de Tiago Cardoso.',
      canonical: 'https://ticardoso.com.br/faq'
    });

    // Add FAQ schema to page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map(item => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="faq-page">
      <Header />
      <main className="faq-content">
        <section className="section-padding">
          <div className="container-custom">
            <button onClick={() => navigate('/')} className="back-button">
              <ArrowLeft size={20} />
              Voltar para home
            </button>
            
            <h1 className="faq-title">FAQ</h1>
            
            <div className="faq-list">
              {faqData.map((item, index) => (
                <div key={index} className="faq-item">
                  <h2 className="faq-question">{item.question}</h2>
                  <p className="faq-answer">{item.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FAQ;
